var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"gh-action-tooltip-host",on:{"mouseenter":_vm.onEnter,"mouseleave":_vm.onLeave}},[_vm._t("default"),_vm._v(" "),(_vm.visible)?_c('span',{ref:"tooltip",staticClass:"gh-action-tooltip",style:(_vm.popupStyle),attrs:{"role":"tooltip"}},[_vm._v(_vm._s(_vm.text))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }